import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetIptvDataQuery, useLazyGetIptvDataQuery } from '../../redux/apis/linkManagement/iptv/index/lmIptvApiSlice'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateIptv from '../../components/IPTV/EditCreateIptv'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import { can } from '../../helpers/auth'

const IptvInfo = React.memo(() => {
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetIptvDataQuery({
    expand: ['last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'APP NAME',
      dataIndex: 'app_name',
      key: 'app_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'VERSION',
      dataIndex: 'version',
      key: 'version',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'SUBSCRIPTION EXPIRY',
      dataIndex: 'subscription_expiry',
      key: 'subscription_expiry',
      filter: true,
      filterType: 'date'
    },
   
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'updated_at',
      key: 'updated_at'
    },
    {
      title: 'LAST UPDATED DATE',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => (
        <div className=''>
          {text.first_name} {text.last_name}
        </div>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <Link
            className='btn btn-warning'
            to={`/iptv/iptv-information/${record?.id}`}
          >
            View
          </Link>
          {can('change_iptv') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_iptv') && create ? (
        <EditCreateIptv
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_iptv') && edit ? (
        <EditCreateIptv
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}
      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />

        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetIptvDataQuery}
            fileName='iptvinfo'
          />
          {can('add_iptv') && (
            <button
              className='btn btn-outline-theme mb-4'
              onClick={() => setCreate(true)}
            >
              Create App
            </button>
          )}
        </div>
      </div>
      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default IptvInfo
